import { render, staticRenderFns } from "./NewArticleModal.vue?vue&type=template&id=203c4e80&scoped=true&"
import script from "./NewArticleModal.vue?vue&type=script&lang=js&"
export * from "./NewArticleModal.vue?vue&type=script&lang=js&"
import style0 from "./NewArticleModal.vue?vue&type=style&index=0&id=203c4e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203c4e80",
  null
  
)

export default component.exports